export function timeDifference(startHours, startMinutes, endHours, endMinutes) {
  if (!startHours || !startMinutes || !endHours || !endMinutes) {
    return "";
  }
  const startDate = new Date(0, 0, 0, startHours, startMinutes);
  const endDate = new Date(0, 0, 0, endHours, endMinutes);

  if (endDate < startDate) {
    endDate.setDate(endDate.getDate() + 1);
  }

  const timeDiff = endDate - startDate;
  const hours = Math.floor((timeDiff % 86400000) / 3600000);
  const minutes = Math.round(((timeDiff % 86400000) % 3600000) / 60000);

  return `${hours}h ${minutes}m`;
}
